import React from 'react'
import Typography from 'aldoo-ra/Typography'
import DropdownSelect from 'aldoo-ra/DropdownSelect'

const SegmentsSelector = ({
  availableSegments,
  selectedSegments,
  loadingSegments,
  error,
  onChange
}) => {
  return (
    <div className="mb-6">
      <Typography component="h2" variant="admin_h4" className="mb-2">
        Target Segments
      </Typography>

      <Typography variant="admin_txt2_dim" className="block mb-3">
        Select specific subscriber segments to target.
      </Typography>

      {loadingSegments ? (
        <div className="flex items-center justify-center py-8">
          <div className="h-6 w-6 animate-spin rounded-full border-b-2 border-admin_primary"></div>
          <Typography variant="admin_body1_dim" className="ml-3 my-0">
            Loading segments...
          </Typography>
        </div>
      ) : availableSegments.length === 0 ? (
        <div className="text-center bg-admin_canvas rounded-lg border border-admin_bordered py-8">
          <Typography variant="admin_body1_dim" className="my-0">
            No segments available. Newsletter will target all subscribers.
          </Typography>
        </div>
      ) : (
        <DropdownSelect
          key={`segments-${availableSegments.length}-${selectedSegments?.id || 'none'}`}
          variant="admin"
          searchEnabled
          allowEmptySelection={false}
          showCheckbox={false}
          enableResetButton={false}
          label="Segments"
          placeholder="Select audience segment..."
          options={availableSegments.map(segment => ({
            value: segment.id,
            id: segment.id,
            name: segment.count !== undefined
              ? `${segment.name} (${segment.count.toLocaleString()})`
              : segment.name,
            description: segment.description,
            count: segment.count
          }))}
          value={loadingSegments ? null : selectedSegments}
          onChange={onChange}
          fixedWidth="100%"
          error={error}
          showItemNamesInSelection={true}
          onItemRender={(segment) => (
            <div className="p-2">
              <Typography variant="admin_label" className="mb-0.5">
                {segment.count !== undefined
                  ? `${segment.name.replace(/ \(\d{1,3}(,\d{3})*\)$/, '')} (${segment.count.toLocaleString()})`
                  : segment.name}
              </Typography>

              {segment.description && (
                <Typography variant="admin_txt1_dim">
                  {segment.description}
                </Typography>
              )}
            </div>
          )}
          onValueItemRender={(segment) => {
            if (!segment) return null
            return segment.name || 'Unknown Segment'
          }}
        />
      )}
    </div>
  )
}

export default SegmentsSelector
